import { createFileRoute } from "@tanstack/react-router";

import { SkillsList } from "@/features/skills";

/**
 * ``/settings/skills`` — "Procedure salvate" (saved skills).
 *
 * Mounted under the modal shell like the other ``/settings/*`` children
 * (modes / brand-kits / notifications). Reached from the avatar drawer's
 * ESPERIENZA section.
 */
export const Route = createFileRoute("/_authed/_modal/settings/skills")({
  component: SkillsList,
});
